import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { list as logistsList } from "sources/books/employees";

class LogistHistoryList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                width: 100,
                filterable: true,
                filterType: "int",
                Cell: ({ value }) => (
                    <Link to={paths.logistHistoryItem(this.props.match.params.truckId, value)}>{value}</Link>
                ),
            },
            {
                Header: "Логист",
                accessor: "displayName",
                id: "logistId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: logistsList,
                            inputProps: { name: "logistId" },
                            propName: "fullNameOrEmail",
                        }}
                    />
                ),
            },
            {
                Header: "Дата привязки",
                accessor: "startedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Дата отвязки",
                accessor: "endedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
        ];
    }

    close = () => {
        const { history, match } = this.props;
        history.push(paths.trucksShow(match.params.truckId));
    };

    renderCreateButton = () => {
        const { history, match, onlyRoot } = this.props;
        const { isRoot } = this.props.roles;
        if (!isRoot && onlyRoot) {
            return null;
        }
        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () => history.push(paths.logistHistoryNew(match.params.truckId)),
        };
        return <div {...props}>Добавление записи</div>;
    };

    renderListComponent = () => {
        const { getList, ...props } = this.props;
        return (
            <SharedReactTable
                {...props}
                getList={(params) => getList({ ...params, truckId: parseInt(props.match.params.truckId) })}
                columns={this.state.tableColumns}
            />
        );
    };
}

export default tableContainer(LogistHistoryList, "logist-history");
